module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content--onepane"
  }, [_c('form', {
    staticClass: "form editor"
  }, [_c('div', {
    staticClass: "form-side"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.symbol),
      expression: "formData.symbol"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.symbol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.symbol = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.setUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "i form-infoLink"
  }, [_vm._v("link")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.industry),
      expression: "formData.industry"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.industry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.industry = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.sector),
      expression: "formData.sector"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.sector)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.sector = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveStock($event)
      }
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("check")]), _vm._v("\r\n        Save\r\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-belly"
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Info"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.symbol),
      expression: "formData.symbol"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.symbol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.symbol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.industry),
      expression: "formData.industry"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.industry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.industry = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.sector),
      expression: "formData.sector"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.sector)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.sector = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Notes",
      "selected": ""
    }
  }, [_c('longform-editor', {
    attrs: {
      "placeholder": "Notes"
    },
    model: {
      value: (_vm.formData.note),
      callback: function($$v) {
        _vm.formData.note = $$v
      },
      expression: "formData.note"
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Financial"
    }
  }, [_c('longform-editor', {
    attrs: {
      "placeholder": "Financial"
    },
    model: {
      value: (_vm.formData.financial),
      callback: function($$v) {
        _vm.formData.financial = $$v
      },
      expression: "formData.financial"
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "SWOT"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.swot.s),
      expression: "formData.swot.s"
    }],
    staticClass: "form-textarea",
    domProps: {
      "value": (_vm.formData.swot.s)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.swot.s = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.swot.w),
      expression: "formData.swot.w"
    }],
    staticClass: "form-textarea",
    domProps: {
      "value": (_vm.formData.swot.w)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.swot.w = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.swot.o),
      expression: "formData.swot.o"
    }],
    staticClass: "form-textarea",
    domProps: {
      "value": (_vm.formData.swot.o)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.swot.o = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.swot.t),
      expression: "formData.swot.t"
    }],
    staticClass: "form-textarea",
    domProps: {
      "value": (_vm.formData.swot.t)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.swot.t = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-foot"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveStock($event)
      }
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("check")]), _vm._v("\r\n        Save\r\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7d694646"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newstock.vue
// module id = 73
// module chunks = 0